module.exports = __webpack_public_path__ + "static/media/sciana2.7a08b0f9.jpg";